import { all, call } from 'redux-saga/effects';
import { runGaViewSelectTintServiceDetector } from './ga-view-tint-service.pdp';
import { runGaClickSelectColorButtonDetector } from './ga-click-select-color-button.pdp';
import { runGaClickSubmitColorSelectButtonDetector } from './ga-click-submit-color-select-button.pdp';
import { runGaUpdateTintServiceInCartDetector } from './ga-update-tint-service-in-cart.pdp';

export function* runSelectTintServiceGaDetectors() {
  yield all([
    call(runGaViewSelectTintServiceDetector),
    call(runGaClickSelectColorButtonDetector),
    call(runGaClickSubmitColorSelectButtonDetector),
    call(runGaUpdateTintServiceInCartDetector),
  ]);
}
